import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function updateSubscriptions(dropbox_role){
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/roles/${dropbox_role.id}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "PUT";
    baseRequestConfig.body = JSON.stringify(dropbox_role);
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}








/** WEBPACK FOOTER **
 ** ./src/connectivity/api.subscriptions.js
 **/